<template>
  <div class="detailContent">
    <div class="topContent">
    </div>
    <div class="bottomContent">
      
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.detailContent{
    height: calc(100% - 56px);
    overflow: auto;
    background-color: #fff;
    .topContent{
      border-bottom: 1px solid #cecece;
      box-sizing: border-box;
    }
    .bottomContent{
    }
}
</style>